import * as React from 'react';
import { CerebroText } from './CerebroText';

export const CerebroBreadcrumb: React.FC = ({ children }) => {
	return (
		<CerebroText variant="breadcrumb" sx={{ marginBottom: 3.25 }}>
			{children}
		</CerebroText>
	);
};
